export const defaultStyle = {
    container: "xl:col-start-7 xl:col-span-6",
    content:
        "bg-mdlzPurple rounded-b-[20px] mb-[21px] text-white transition-[max-height,opacity] duration-[400ms] overflow-hidden eas-in-out",
    button: "w-full bg-mdlzPurple text-white p-[20px] text-left rounded-[20px] flex items-center justify-between cursor-pointer transition-all duration-300",
    buttonOpen: "rounded-b-none mb-[-1px]",
    label: "subheading-text uppercase",
    icon: "transition-transform duration-300",
    iconOpen: "rotate-180",
}
